import { useContext, useEffect, useRef, useState } from "react";
import "./style/AudioPlayer.css";
import { Link, useLocation, useParams } from "react-router-dom";
import PhaseLayout from "../phase1_6Layout/PhaseLayout";
import axios from "axios";
import { AuthContext } from "../auth/AuthProvider";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";

export default function AudioPlayer({
  audioSrc,
  title,
  subtitle,
  audioEnded,
  phase,
  question,
  questionName,
}) {
  const { user, googleUser, prevLocation } = useContext(AuthContext);
  const audioRef = useRef(null);
  const savedTimeRef = useRef(0);
  const isReadyRef = useRef(false);

  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [themeProgress, setThemeProgress] = useState(0);

  const [theme, setTheme] = useState({});

  const [isOpen, setIsOpen] = useState(false);

  const [loading, setLoading] = useState(true);

  const { id } = useParams();

  const { apiUrl } = useContext(AuthContext);

  const location = useLocation();

  useEffect(() => {
    // console.log(prevLocation);
    // localStorage.setItem("location", location.pathname);

    async function themeData() {
      setLoading(true);
      try {
        const res = await axios.get(`${apiUrl}/theme/${id}`);

        setTheme(res.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }

    themeData();
  }, []);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const updateTime = () => {
      if (audio.currentTime === audio.duration) {
        setIsPlaying(false);
      }
      const t = audio.currentTime;
      savedTimeRef.current = t;
      setCurrentTime(t);
    };
    const setMeta = () => setDuration(audio.duration);

    audio.addEventListener("timeupdate", updateTime);
    audio.addEventListener("loadedmetadata", setMeta);
    // audio.addEventListener("ended", handleEnded);

    return () => {
      audio.removeEventListener("timeupdate", updateTime);
      audio.removeEventListener("loadedmetadata", setMeta);
      // audio.removeEventListener("ended", handleEnded);
    };
  }, [audioEnded]);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    audio.currentTime = savedTimeRef.current;

    const tryAutoPlay = async () => {
      try {
        await audio.play();
        setIsPlaying(true);
      } catch (err) {
        // Autoplay blocked → user must press play
        setIsPlaying(false);
      }
    };

    tryAutoPlay();
  }, [audioSrc]);

  useEffect(() => {
    if (!user && !googleUser) return;

    async function loadData() {
      try {
        const identifier = user ? user.username : googleUser.email;

        const userEndpoint = user ? "byUserAndTheme" : "byGoogleUserAndTheme";
        const fullUserEndpoint = user ? "byUserInfo" : "byGoogleUserInfo";

        const latestQuestion = await axios.get(
          `${apiUrl}/user-question/${userEndpoint}/${identifier}/${id}`,
        );

        const sortedLatestQuestion = latestQuestion.data.sort(
          (a, b) => b.questionId - a.questionId,
        );

        const lastQuestion = await axios.get(
          `${apiUrl}/user-question/${fullUserEndpoint}/${identifier}/${id}/Phase 5`,
        );

        const completed = lastQuestion.data.some(
          (q) =>
            q.questionIndex === 5 &&
            q.phaseName === "Phase 5" &&
            q.questionNumber === "Question 5_5",
        );

        if (completed) {
          setThemeProgress(5);
          return;
        }

        setThemeProgress(sortedLatestQuestion[0]?.questionIndex);
      } catch (error) {}
    }

    loadData();
  }, [user, googleUser, apiUrl]);

  const handleEnded = () => {
    setIsPlaying(false);
    if (audioEnded) audioEnded();
    // audio.addEventListener("ended", handleEnded);
  };

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying((prev) => !prev);
  };

  const seekBackward = () => {
    const audio = audioRef.current;
    if (!audio) return;

    const newTime = Math.max(0, audio.currentTime - 10);
    audio.currentTime = newTime;
    setCurrentTime(newTime);
  };

  const seekForward = () => {
    const audio = audioRef.current;
    if (!audio) return;

    const newTime = Math.min(duration, audio.currentTime + 10);
    audio.currentTime = newTime;
    setCurrentTime(newTime);
  };

  const formatTime = (t) =>
    `${Math.floor(t / 60)}:${String(Math.floor(t % 60)).padStart(2, "0")}`;

  return (
    <>
      <div className="relife-player">
        <div className="back-btn-div">
          <div>
            <Link
              to={`/session/${id}`}
              className="back-btn"
              style={{ color: "rgba(242, 237, 229, 0.78)" }}
            >
              ❮
            </Link>
          </div>

          <section className="audioSection">
            <div>
              <p>{theme.title}</p>
            </div>
            <div>
              <p>{phase}</p>
              <p>•</p>
              <p>Question {question}/5</p>
            </div>

            {/* <hr /> */}
          </section>

          <div className="hamburger-div">
            {!isOpen && (
              <button
                id="hamburger"
                className="hamburger"
                type="button"
                onClick={() => setIsOpen(true)}
                aria-label="Open menu"
                style={{
                  color: "rgba(242, 237, 229, 0.78)",
                }}
              >
                ☰
              </button>
            )}

            {isOpen && (
              <div
                className="sidebar-backdrop"
                onClick={() => setIsOpen(false)}
              />
            )}
          </div>
        </div>

        {/* <div style={{ color: "gray" }} className="phaseSectionParagraph psp">
          <div
            className="progressLineParent"
            id="progressLineParent"
            style={{
              // width: "14px",
              width: `${Math.floor(((themeProgress || 0) / 5) * 100)}%`,
            }}
          >
            <div className="progressLineChild" id="progressLineChild"></div>
          </div>
        </div> */}

        {/* <div id="childAudioPlayer"> */}
        <audio ref={audioRef} src={audioSrc} />

        <div>
          {/* <p>{phase}</p>
          <p>{question}</p> */}
          <p className="audioQuestion" style={{ fontSize: "1rem" }}>
            {questionName}
          </p>
        </div>

        <h1>{title}</h1>

        <div className="orb" />

        <div className="timeline">
          <span>{formatTime(currentTime)}</span>
          <input
            type="range"
            min="0"
            max={duration || 0}
            value={currentTime}
            onChange={(e) => {
              audioRef.current.currentTime = e.target.value;
              setCurrentTime(e.target.value);
              audioRef.current.play();
            }}
            style={{ cursor: "pointer" }}
          />
          <span>{formatTime(duration)}</span>
        </div>

        <div className="controls">
          <button
            className="icon"
            onClick={seekBackward}
            style={{ cursor: "pointer", color: "rgba(242, 237, 229, 0.78)" }}
          >
            ⟲ 10
          </button>
          <button
            className="play"
            onClick={togglePlay}
            style={{ cursor: "pointer" }}
            aria-label={isPlaying ? "Pause" : "Play"}
          >
            {isPlaying ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 20"
                aria-hidden="true"
              >
                <rect x="6" y="5" width="4" height="14" fill="black" rx="1" />
                <rect x="14" y="5" width="4" height="14" fill="black" rx="1" />
              </svg>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 20"
                aria-hidden="true"
              >
                <polygon points="8,5 19,12 8,19" fill="black" />
              </svg>
            )}
          </button>
          <button
            className="icon"
            onClick={seekForward}
            style={{ cursor: "pointer", color: "rgba(242, 237, 229, 0.78)" }}
          >
            10 ⟳
          </button>
        </div>

        {/* <div>
          <div id="transcript">
            <button>VIEW TRANSCRIPT</button>
            <p>{subtitle}</p>
          </div>

          <button onClick={handleEnded} className="btn primary">
            Continue Journey →
          </button>
        </div> */}

        <div id="transcriptParent">
          <div id="transcript">
            {/* <button style={{ marginTop: "1rem" }}>VIEW TRANSCRIPT</button> */}
            <p>{subtitle}</p>
          </div>

          <button onClick={handleEnded} className="btn primary">
            Continue Journey →
          </button>
        </div>
      </div>
      {/* </div> */}

      <div
        id="sidebarTheme"
        className={`sidebar ${isOpen ? "open" : "closed"}`}
      >
        <button
          id="closeBtn"
          className="close-btn"
          type="button"
          onClick={() => setIsOpen(false)}
          aria-label="Close menu"
          style={{
            color: "rgba(242, 237, 229, 0.78)",
          }}
        >
          X
        </button>

        <div className="plParent">
          <PhaseLayout />
        </div>
      </div>
    </>
  );
}
